export const BHO_HELP_CENTER_URL =
  'https://intercom.help/doitlife/en/collections/3869799-quick-guide-to-big-help-out-app';

export const ORG_HELP_CENTER_URL =
  'https://intercom.help/doitlife/en/collections/3869795-for-voluntary-organisations';
